module.exports = __webpack_public_path__ + "static/media/pushLogo.24e5fbc0.svg";